/**
 *
 * Asynchronously loads the component for Layout
 *
 */

import { lazyLoad } from 'utils/loadable';

const Layout = lazyLoad(
  () => import('./index'),
  module => module.Layout,
);

export default Layout;
